import { render, staticRenderFns } from "./latestContract.vue?vue&type=template&id=4af31382&scoped=true&"
import script from "./latestContract.vue?vue&type=script&lang=js&"
export * from "./latestContract.vue?vue&type=script&lang=js&"
import style0 from "./latestContract.vue?vue&type=style&index=0&id=4af31382&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af31382",
  null
  
)

export default component.exports